import PageContainer from '@/common/components/PageContainer'
import useQueryGetGameProviderGameTypeList from '@/modules/game/api/hooks/useQueryGetProviderGameTypeList'
import ProviderListListing from '@/modules/game/components/ProviderList/ProviderListListing'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useProviderGameTypeSelector } from '@/common/hooks/useProviderGameTypeSelector'

function ProviderPage() {
	const { gameType } = useProviderGameTypeSelector()
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
		displayName: searchQuery,
		gameType:
			(gameType as
				| 'SLOT'
				| 'CASINO'
				| 'LOTTO'
				| 'SPORT'
				| 'FISHING'
				| undefined) || undefined,
	}
	const { data, isLoading } = useQueryGetGameProviderGameTypeList(payload)

	return (
		<PageContainer>
			<ProviderListListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedProviderPage = withUserPermission(ProviderPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_GAME],
})
export default GuardedProviderPage
